import { axiosInstance } from '../axios';

const API_URL = '/api/suppliers';

class SupplierService {

  async findByName(searchTerm) {

    const params = new URLSearchParams();

    if (searchTerm !== null) {
      params.append('searchTerm', searchTerm);
    }


    const config = {
      params: params,
    };

    return axiosInstance.get(`${API_URL}/findSuppliers`, config);
  }

  async addSupplier(supplier) {
    return await axiosInstance.put(`${API_URL}/supplier`, supplier);
  }
}

export default new SupplierService();
